import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
import LinkBlock from '@/components/optypes/frontend/ThreeColumnResources/blocks/LinkBlock'

const Components = {
  linkblock: LinkBlock,
}

import OnepagerFooter from '@/components/optypes/headlesss-components/OnepagerFooter'

const MainComponentRenderer = () => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: returnValue('bgcolor', opDesign, pageDesign),
        color: returnValue('textcolor', opDesign, pageDesign),
      }}
    >
      {/* background image */}
      {returnValue('headerbgimage', opDesign, pageDesign) && (
        <div
          className={Classnames(
            'fixed top-0 left-0 z-0 h-full w-full  bg-cover bg-no-repeat',
            {
              'bg-center':
                returnValue('headerbgposition', opDesign, pageDesign) ==
                'center',
              'bg-top':
                returnValue('headerbgposition', opDesign, pageDesign) == 'top',
              'bg-bottom':
                returnValue('headerbgposition', opDesign, pageDesign) ==
                'bottom',
            }
          )}
          style={{
            backgroundImage: `url(${returnValue(
              'headerbgimage',
              opDesign,
              pageDesign
            )})`,
            opacity: returnValue('headerbgopacity', opDesign, pageDesign),
          }}
        ></div>
      )}

      {/* header */}
      <div className="pt-28 pb-40 z-20 relative">
        <div className="container max-w-7xl mx-auto text-center">
          <h1
            className={Classnames(
              'font-bold leading-tight text-5xl mx-auto md:w-2/3',
              {}
            )}
            style={{
              color: returnValue('headertextcolor', opDesign, pageDesign),
            }}
          >
            <StaticContentWrapper contentKey="headline">
              {returnValue('headline', opStatic, pageStatic)}
            </StaticContentWrapper>
          </h1>
          <div className="mt-6 mx-auto md:w-1/2 text-center flex justify-center text-2xl font-medium">
            <StaticContentWrapper contentKey="subheadline">
              {returnValue('subheadline', opStatic, pageStatic)}
            </StaticContentWrapper>
          </div>
        </div>
      </div>

      {/* three columns */}
      <div className="-mt-20 relative z-20">
        <div className="grid grid-cols-3 gap-6 container max-w-7xl mx-auto">
          {pageBlocks.map((block, index) => (
            <BlockRenderer
              key={index}
              index={index}
              Components={Components}
              block={block}
            />
          ))}
        </div>

        {builder && (
          <div className="my-3 flex justify-center">
            <AddBlockBuilder autoType="linkblock" btnText="Add Link" />
          </div>
        )}
      </div>

      <div className="py-12 z-20 relative">
        <OnepagerFooter />
      </div>
    </div>
  )
}

export default MainComponentRenderer
